import React, {
  ChangeEvent,
  FormEvent,
  useCallback,
  useEffect,
  useState,
} from "react"
import {
  EducationalRecord,
  EducationalRecordCredentials,
  EmploymentRecord,
  EmploymentRecordCredentials,
  Form,
  OLevelResult,
  OLevelResultCredentials,
  SubjectInterface,
  UploadRecordCredentials,
  stageLevel,
  stages,
  useAppNotificationStore,
  useApplicationStore,
  useAuthStore,
  useProfileStore,
} from "stores"
import {
  Button,
  ChooseFile,
  H4,
  H6,
  IconButton,
  Input,
  Label,
  ModalPortal,
  P1,
  P2,
  SelectInput,
  SelectOption,
  Table,
  TableData,
  TableHeader,
  TextAnchor,
  TextButton,
} from "components"
import { AddCircle, Eye, EyeSlash, Maximize4, Trash } from "iconsax-react"
import { images } from "assets"
import { useNavigate } from "react-router-dom"
import { BASEURL, throttle } from "utils"
import { UploadOlevelResults } from "../UploadOlevelResult"
import EducationalRecordComp from "./EducationalRecord"

export const EmploymentRecordComp: React.FC<{}> = () => {
  const { setDashboardContext, toast } = useAppNotificationStore()
  const navigate = useNavigate()
  const { profile } = useProfileStore()
  const [educationalRecordForm] = useState(
    new Form<EducationalRecordCredentials>()
  )
  const [employmentRecordForm] = useState(
    new Form<EmploymentRecordCredentials>()
  )
  const [uploadForm] = useState(new Form<UploadRecordCredentials>())
  const {
    getQualification,
    getDateRange,
    addOLevelSubject,
    // uploadFile,
    addEducationalRecord,
    addOLevelResult,
    addEmploymentRecord,
    getEducationalRecords,
    getOLevelResults,
    getEmploymentRecords,
    deleteEducationalRecord,
    deleteOLevelResult,
    deleteEmploymentRecord,
    updateStage,
    getSubjects,
    getGrades,
    qualifications,
    dateRanges,
    grades,
    subjects,
    educationalRecords,
    oLevelResults,
    deleteOLevelSubject,
    employmentRecords,
  } = useApplicationStore()

  console.log(
    useState<Form<OLevelResultCredentials>>(
      new Form<OLevelResultCredentials>({
        examName: "",
        examNumber: "",
        examYear: "",
        subjects: [],
      })
    )
  )
  const [olevelResultForm, displayOLevelResultForm] = useState<
    Form<OLevelResultCredentials>
  >(
    new Form<OLevelResultCredentials>({
      examName: "",
      examNumber: "",
      examYear: "",
      subjects: [],
    })
  )

  const [viewResults, setViewResults] = useState<OLevelResult>()
  const [examNumber, setExamNumber] = React.useState("")
  const [showModal, setShowModal] = React.useState(false)
  const [examSubjects, setExamSubjects] = useState<
    OLevelResultCredentials["subjects"]
  >([])
  const [educationalRecordsUploads, setEducationalRecordsUploads] =
    useState<EducationalRecord[]>()
  const [olevelResultsUploads, setOlevelResultsUploads] =
    useState<OLevelResult[]>()
  const [employmentUploads, setEmploymentUploads] = useState<
    EmploymentRecord[]
  >([])

  useEffect(() => {
    setDashboardContext("Records")
    const type = "EmploymentRecord"
    uploadForm.setCredential("documentType", type)
    setEmploymentUploads(employmentRecords!)
  }, [
    educationalRecords,
    employmentRecords,
    oLevelResults,
    profile?.nextStage,
    setDashboardContext,
    uploadForm,
  ])

  const [grade, setGrade] = useState<string>()
  const [subject, setSubject] = useState<SubjectInterface>()
  const [subjectModal, setSubjectModal] = useState<SubjectInterface>()
  const [gradeModal, setGradeModal] = useState<string>()

  const initializePage = useCallback(async () => {
    try {
      await getEmploymentRecords()
      await getDateRange().then((_) => {
        employmentRecordForm.setCredential("startDate", dateRanges.startDate[0])
        employmentRecordForm.setCredential("endDate", dateRanges.endDate[0])
      })
    } catch (error) {
      console.log(error)
      toast.error("Unable to get qualifications")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast, educationalRecordForm, olevelResultForm, employmentRecordForm])

  useEffect(() => {
    return throttle(() => {
      initializePage()
    })
  }, [initializePage])

  const handleAddEducationalRecord = async (e: FormEvent) => {
    e.preventDefault()
    educationalRecordForm.submitting(true)

    try {
      educationalRecordForm.submitting(false)
      await addEducationalRecord({
        ...educationalRecordForm.credentials,
        // name: educationalRecordForm.credentials.qualification,
      }).then((resp) => {
        if (resp.isSuccessful === true) {
          toast.success(resp.message)
          educationalRecordForm.setCredentials({
            startDate: dateRanges.startDate[0],
            endDate: dateRanges.endDate[0],
            grade: "",
            qualifications: qualifications[0],
          })
        } else {
          toast.error(resp.message)
        }
      })
    } catch (error: any) {
      educationalRecordForm.submitting(false)
      console.log(error)
      toast.error(error?.message as string)
    }
  }

  const handleAddOLevelResult = async (e: FormEvent) => {
    e.preventDefault()
    olevelResultForm.submitting(true)

    try {
      await addOLevelResult({
        ...olevelResultForm.credentials,
        subjects: examSubjects,
      }).then((resp) => {
        olevelResultForm.submitting(false)
        if (resp.isSuccessful === true) {
          toast.success(resp.message)
          olevelResultForm.setCredentials({
            examName: "",
            examNumber: "",
            examYear: "",
            subjects: [],
          })
          setExamNumber("")
          setExamSubjects([])
        } else {
          toast.error(resp.message)
        }
      })
    } catch (error: any) {
      olevelResultForm.submitting(false)
      console.log(error)
      toast.error(error?.message as string)
    }
  }

  const handleAddEmploymentRecord = async (e: FormEvent) => {
    e.preventDefault()
    olevelResultForm.submitting(true)

    try {
      await addEmploymentRecord(employmentRecordForm.credentials).then(
        (resp) => {
          if (resp.isSuccessful === true) {
            toast.success(resp.message)
            employmentRecordForm.setCredentials({
              employerName: "",
              designation: "",
              startDate: dateRanges.startDate[0],
              endDate: dateRanges.endDate[0],
            })
          } else {
            toast.error(resp.message)
          }
        }
      )
    } catch (error: any) {
      employmentRecordForm.submitting(false)
      console.log(error)
      toast.error(error?.message as string)
    }
  }

  const handleNext = async () => {
    await updateStage({ currentStage: profile?.nextStage! }).then((resp) => {
      if (resp.isSuccessful === true) {
        if (profile?.nextStage === stages.EducationalRecord) {
          useProfileStore.setState({
            profile: { ...profile, nextStage: stages.OlevelResult },
          })
        }
        if (profile?.nextStage === stages.OlevelResult) {
          useProfileStore.setState({
            profile: { ...profile, nextStage: stages.EmploymentRecord },
          })
        }
        if (profile?.nextStage === stages.EmploymentRecord) {
          useProfileStore.setState({
            profile: { ...profile, nextStage: stages.PictureUpload },
          })
          navigate("/dashboard/registration/picture-upload")
        }
      }
    })
  }

  const handlePrevious = () => {
    if (profile?.nextStage === stages.EducationalRecord) {
      // useProfileStore.setState({
      //   profile: { ...profile, nextStage: stages.OlevelResult },
      // })
      navigate("/dashboard/registration/program-choices")
    }
    if (profile?.nextStage === stages.OlevelResult) {
      useProfileStore.setState({
        profile: { ...profile, nextStage: stages.EducationalRecord },
      })
    }
    if (profile?.nextStage === stages.EmploymentRecord) {
      useProfileStore.setState({
        profile: { ...profile, nextStage: stages.OlevelResult },
      })
    }
  }

  return (
    <>
      <form
        onSubmit={handleAddEmploymentRecord}
        encType="multipart/form-data"
        className="w-full lg:w-[536px] flex flex-col gap-8"
      >
        <div className="space-y-[5px] w-full flex justify-between items-center gap-3">
          <div className="w-full">
            <Label
              htmlFor="employerName"
              aria-required
            >
              Employer Name
            </Label>
            <Input
              id="employerName"
              required
              disabled={employmentRecordForm.isSubmitting}
              placeholder="Enter your employer name"
              onChange={(e) =>
                employmentRecordForm.setCredential(
                  "employerName",
                  e.currentTarget.value
                )
              }
            />
          </div>
          <div className="w-full">
            <Label
              htmlFor="designation"
              aria-required
            >
              Designation
            </Label>
            <Input
              id="designation"
              required
              disabled={employmentRecordForm.isSubmitting}
              placeholder="Enter your designation"
              onChange={(e) =>
                employmentRecordForm.setCredential(
                  "designation",
                  e.currentTarget.value
                )
              }
            />
          </div>
        </div>

        <div className="space-y-[5px] w-full flex justify-between items-center gap-3">
          <div className="w-full">
            <Label
              htmlFor="start-date"
              aria-required
            >
              Start Date
            </Label>
            <SelectInput
              id="start-date"
              required
              disabled={employmentRecordForm.isSubmitting}
              onChange={(e) =>
                employmentRecordForm.setCredential(
                  "startDate",
                  e.currentTarget.value
                )
              }
            >
              {dateRanges.startDate.map((option, index) => (
                <SelectOption
                  key={index}
                  value={option}
                >
                  {option}
                </SelectOption>
              ))}
            </SelectInput>
          </div>
          <div className="w-full">
            <Label
              htmlFor="end-date"
              aria-required
            >
              End Date
            </Label>
            <SelectInput
              id="end-date"
              required
              disabled={employmentRecordForm.isSubmitting}
              onChange={(e) =>
                employmentRecordForm.setCredential(
                  "endDate",
                  e.currentTarget.value
                )
              }
            >
              {dateRanges.endDate.map((option, index) => (
                <SelectOption
                  key={index}
                  value={option}
                >
                  {option}
                </SelectOption>
              ))}
            </SelectInput>
          </div>
        </div>
        <>
          <div className="flex justify-end">
            <Button
              type="submit"
              title={"Add Record"}
              color="primary"
              className="w-52"
              disabled={educationalRecordForm.isSubmitting}
              submitting={educationalRecordForm.isSubmitting ? "true" : "false"}
            >
              Add Record
            </Button>
          </div>
          <H6 className="text-accentText font-semibold">Records</H6>
        </>
      </form>

      <div className="flex flex-col gap-0.5 w-full lg:w-[536px]">
        <div className="w-full">
          <Table
            cols={4}
            headers={[
              <TableHeader>#</TableHeader>,
              <TableHeader>Employer's&nbsp;Name</TableHeader>,
              <TableHeader>From</TableHeader>,
              <TableHeader>To</TableHeader>,
            ]}
            rows={
              employmentUploads?.map((record, index) => ({
                data: [
                  <TableData key={index}>{index + 1}</TableData>,
                  <TableData key={index}>{record.employerName}</TableData>,
                  <TableData key={index}>{record.startDate}</TableData>,
                  <TableData key={index}>{record.endDate}</TableData>,
                  <TextButton
                    type="button"
                    title="View"
                    className="flex gap-3 items-center text-stateError"
                    onClick={async () => {
                      await deleteEmploymentRecord({
                        employmentRecordId: record.employmentRecId,
                      }).then((resp) => {
                        if (resp.isSuccessful === true) {
                          toast.success(resp.message)
                        } else {
                          toast.error(resp.message)
                        }
                      })
                    }}
                  >
                    <Trash size={18} />
                  </TextButton>,
                ],
              }))!
            }
          />
        </div>
      </div>
    </>
  )
}
